function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SettingsTemplate = require('./settings.template');
var SaitoContacts = require('../../../lib/saito/ui/modals/saito-contacts/saito-contacts');
var RedSquareSettings = /*#__PURE__*/function () {
  function RedSquareSettings(app, mod, container) {
    _classCallCheck(this, RedSquareSettings);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.contacts = new SaitoContacts(app, mod, true);
  }
  return _createClass(RedSquareSettings, [{
    key: "render",
    value: function render() {
      if (document.getElementById('redsquare-settings')) {
        this.app.browser.replaceElementById(SettingsTemplate(this.app, this.mod), 'redsquare-settings');
      } else {
        this.app.browser.addElementToSelector(SettingsTemplate(this.app, this.mod), this.container);
      }
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var settings_self = this;
      var modtools_self = this.app.modules.returnModuleBySlug('modtools');
      if (document.getElementById('blacklisted-accounts')) {
        var _modtools_self$blackl;
        if (modtools_self !== null && modtools_self !== void 0 && (_modtools_self$blackl = modtools_self.blacklisted_publickeys) !== null && _modtools_self$blackl !== void 0 && _modtools_self$blackl.length) {
          document.getElementById('blacklisted-accounts').onclick = function (e) {
            _this.contacts.title = 'Blacklisted Accounts';
            _this.contacts.multi_button = 'Remove from Blacklist';
            _this.contacts.callback = function (keys) {
              var _iterator = _createForOfIteratorHelper(keys),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var key = _step.value;
                  _this.app.connection.emit('saito-unblacklist', key);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              _this.render();
            };
            _this.contacts.render(modtools_self.blacklisted_publickeys);
          };
        }
      }
      if (document.getElementById('whitelisted-accounts')) {
        var _modtools_self$whitel;
        if (modtools_self !== null && modtools_self !== void 0 && (_modtools_self$whitel = modtools_self.whitelisted_publickeys) !== null && _modtools_self$whitel !== void 0 && _modtools_self$whitel.length) {
          document.getElementById('whitelisted-accounts').onclick = function (e) {
            _this.contacts.title = 'Whitelisted Accounts';
            _this.contacts.multi_button = 'Remove from Whitelist';
            _this.contacts.callback = function (keys) {
              var _iterator2 = _createForOfIteratorHelper(keys),
                _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var key = _step2.value;
                  _this.app.connection.emit('saito-unwhitelist', key);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              _this.render();
            };
            _this.contacts.render(modtools_self.whitelisted_publickeys);
          };
        }
      }
      if (document.getElementById('add-whitelist')) {
        document.getElementById('add-whitelist').onclick = function (e) {
          e.stopPropagation();
          e.preventDefault();
          _this.contacts.title = 'Saved Keys';
          _this.contacts.multi_button = 'Add to Whitelist';
          _this.contacts.callback = function (keys) {
            var _iterator3 = _createForOfIteratorHelper(keys),
              _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var key = _step3.value;
                _this.app.connection.emit('saito-whitelist', {
                  publicKey: key,
                  duration: -1
                });
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
            _this.render();
          };
          _this.contacts.render();
        };
      }

      //
      // curated / unfiltered
      //
      var container = document.getElementById('curation-toggle');
      var options = container.querySelectorAll('#curation-toggle .toggle-option');
      var tc = document.querySelector('.tweet-container');
      options.forEach(function (option) {
        option.addEventListener('click', function () {
          options.forEach(function (o) {
            return o.classList.remove('active');
          });
          option.classList.add('active');
          if (option === options[1]) {
            container.classList.add('active-right');
            _this.mod.curated = false;
            if (tc) {
              tc.classList.remove('active-curation');
            }
            _this.mod.saveOptions();
          } else {
            container.classList.remove('active-right');
            _this.mod.curated = true;
            if (tc) {
              tc.classList.add('active-curation');
            }
            _this.mod.saveOptions();
          }
        });
      });
    }
  }]);
}();
module.exports = RedSquareSettings;